<template>
  <div>
    <button class="red-button" style="float: right" @click="addUser()">Add New User</button>
    <h2>Users:</h2>
    <table>
      <tr>
        <th>ID</th>
        <th>Actions</th>
        <th>Role</th>
        <th>Email</th>
        <th>Name</th>
        <th>Site</th>
      </tr>
      <tr v-for="user in users">
        <td>{{ user.id }}</td>
        <td>
          <div style="display: inline-block; white-space: nowrap">
            <button class="red-button" @click="editUser(user.id)">Edit</button>
            <button class="red-button" @click="deleteUser(user.id)">Delete</button>
            <router-link :to="`/samples-user/${user.id}`">
              <button class="red-button">Samples</button>
            </router-link>
          </div>
        </td>
        <td style="white-space: nowrap">{{ lodash.capitalize(user.role) }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.name }}</td>
        <td><div v-for="loc in user.locations" style="white-space: nowrap">{{ loc.name }} <span style="color: #AAA">[ID: {{ loc.id }}]</span></div></td>
      </tr>
    </table>
    <div class="modal-mask" v-show="showModal">
      <div class="modal-container" @click.stop>
        <div class="modal-header">
          <button style="float: right;" class="red-button" @click="showModal = false">X</button>
          <h3 v-show="!user.id">Add User</h3>
          <h3 v-show="user.id">Edit User</h3>
        </div>
        <div class="alert alert-danger" v-if="errors">
          <div v-for="error in errors">{{ error }}</div>
        </div>
        <form @submit="saveUser">
          <div class="modal-body">
            <label class="form-label">Role
              <select required class="form-control" v-model="user.role">
                <option value="admin">Admin</option>
                <option value="winemaker-single">Winemaker-single</option>
                <option value="winemaker-multi">Winemaker-multi</option>
              </select>
            </label>
            <label class="form-label">Name
              <input required v-model="user.name" class="form-control">
            </label>
            <label class="form-label">Email
              <input required v-model="user.email" type="email" class="form-control">
            </label>
            <label class="form-label">Password
              <input :required="!user.id" type="password"
                     v-model="user.password" class="form-control"
                     :placeholder="user.id ? '**********' : ''">
            </label>
            <label class="form-label">
              Sites<br />
              <div style="width: 70%; display: inline-block">
                <input class="form-control" v-model="newLocation" placeholder="New Site">
              </div>
              <div style="display: inline-block">
                <button type="button" class="red-button" @click="newSite">Add</button>
              </div>
            </label>
            <label class="form-label">
              <multiselect
                v-model="user.locations"
                :multiple="true"
                placeholder="Link Existing"
                :taggable="true"
                :options="$store.state.locations"
                track-by="id"
                :hideSelected="true"
                :label="'displayName'">
              </multiselect>
            </label>
          </div>
          <div class="modal-footer text-right">
            <button class="red-button">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import lodash from 'lodash';
import axios from 'axios';
import Multiselect from 'vue-multiselect';


export default {
  name: 'Users',
  components: {
    Multiselect,
  },
  data() {
    return {
      moment,
      lodash,
      errors: [],
      showModal: false,
      users: [],
      user: {
        id: null,
        email: '',
        password: '',
        name: '',
        role: '',
        locations: [],
      },
      newLocation: '',
    };
  },
  mounted() {
    const app = this;
    axios.get('locations')
      .then((resp) => {
        // console.log(resp.data);
        const locations = resp.data;
        locations.forEach((location, index) => {
          locations[index].displayName = `${location.name} [${location.id}]`;
        });
        this.$store.state.locations = locations;
      })
      .catch((resp) => {
        // console.log(resp);
        alert('Problem!');
      });
    this.listUsers();
  },
  methods: {
    newSite() {
      const loc = {
        name: this.newLocation,
        displayName: `${this.newLocation} [new]`,
      };
      if (!this.user.locations) this.user.locations = [];
      this.user.locations.push(loc);
      this.$store.state.locations.push(loc);
      this.newLocation = '';
    },
    listUsers() {
      const app = this;
      axios.get('users')
        .then((resp) => {
          // console.log(resp.data);
          app.users = resp.data;
          app.users.forEach((user, i) => {
            app.users[i].locations.forEach((location, j) => {
              app.users[i].locations[j].displayName = `${location.name} [${location.id}]`;
            });
          });
        })
        .catch((resp) => {
          // console.log(resp);
          alert('Problem!');
        });
    },
    addUser() {
      this.errors = [];
      this.newLocation = '';
      const app = this;
      app.user = { role: 'winemaker-single' };
      app.showModal = true;
    },
    editUser(id) {
      this.errors = [];
      this.newLocation = '';
      const app = this;
      app.user = {};
      app.users.forEach((u) => {
        if (u.id === id) app.user = u;
      });
      app.showModal = true;
    },
    saveUser(e) {
      this.errors = [];
      e.preventDefault();
      const app = this;
      if (!this.user.name || this.user.name.length < 1) this.errors.push('Please enter a name.');
      if (!this.user.email || this.user.email.length < 5) this.errors.push('Please enter an email.');
      if (!this.user.role) this.errors.push('Please select a role.');
      if (!this.user.id && (!this.user.password || this.user.password.length < 5)) {
        this.errors.push('Please enter a password at least 6 characters in length.');
      }
      if (this.errors.length > 0) return;
      app.showModal = false;
      let method = 'PUT';
      let url = `users/${this.user.id}`;
      if (!this.user.id) {
        method = 'POST';
        url = 'users';
      }
      // console.log(this.user);
      axios({ url, method, data: this.user })
        .then((resp) => {
          // console.log(resp.data);
          this.listUsers();
        })
        .catch((resp) => {
          // console.log(resp);
          alert('Problem!');
        });
    },
    deleteUser(id) {
      if (!confirm('Are you sure you want to delete this user? It will unlink this user to their site location, but keep their samples.')) return;
      axios.delete(`users/${id}`)
        .then((resp) => {
          // console.log(resp.data);
          this.listUsers();
        })
        .catch((resp) => {
          // console.log(resp);
          alert('Problem!');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/_colors.scss';
  @import '../assets/_globals.scss';
  @import '../assets/_modal.scss';
  @import '../assets/_common.scss';

  .modal-container {
    width: 300px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Users.vue